import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Component } from '@fullcalendar/core';
import { CashVoucherListComponent } from './CashVoucherList/CashVoucherList.component';
import { CashVoucherComponent } from './CashVoucher/CashVoucher.component';
import { JournalVoucherListComponent } from './JournalVoucherList/JournalVoucherList.component';
import { JournalVoucherComponent } from './JournalVoucher/JournalVoucher.component';
import { DesignListComponent } from './DesignList/DesignList.component';
import { EstimateVoucherListComponent } from './EstimateVoucherList/EstimateVoucherList.component';
import { EstimateVoucherComponent } from './EstimateVoucher/EstimateVoucher.component';
import { PurchaseVoucherListComponent } from './PurchaseVoucherList/PurchaseVoucherList.component';
import { PurchaseInvoiceComponent } from './PurchaseInvoice/PurchaseInvoice.component';
import { DesignMasterComponent } from './DesignMaster/DesignMaster.component';
import { scan } from 'rxjs/operators';
import { CodeScanComponent } from './CodeScan/CodeScan.component';

const routes: Routes = [
    {
        path: 'scan',
        component: CodeScanComponent
    },
   
    {
        path: 'cashVoucher',
        component: CashVoucherListComponent
    },
    {
        path: 'cashVoucherEntry',
        component: CashVoucherComponent
    },
    {
        path: 'journalVoucher',
        component: JournalVoucherListComponent
    },
    {
        path:'journalVoucherEntry',
        component: JournalVoucherComponent
    },
    {
        path:'designList',
        component: DesignListComponent
    },
    {
        path:'designMaster',
        component: DesignMasterComponent
    },
    {
        path:'estimateList',
        component: EstimateVoucherListComponent
    },
    {
        path:'estimateVoucher',
        component: EstimateVoucherComponent
    },
    {
        path:'purchaseList',
        component: PurchaseVoucherListComponent
    },
    {
        path:'purchaseInvoice',
        component: PurchaseInvoiceComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EntryFormRoutingModule { }
